import { ElementRef } from "@angular/core";
import { downloadedFile } from "../../services/base/base.service";

export function detectar_mobile() {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    }
    else {
        return false;
    }
}

export function gerarArquivo(file: downloadedFile) {
    const url = window.URL.createObjectURL(file.blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


export function mobile_focus_without_keyboard(input: ElementRef<any>, selectText: boolean = false) {
    input.nativeElement.setAttribute('inputmode', "none");
    setTimeout(() => {
        input.nativeElement.focus();
        if(selectText){
            input.nativeElement.select();
        }
    }, 500);    
}


export function mobile_focus_with_keyboard(input: ElementRef<any>) {
    // input.nativeElement.setAttribute('inputmode', "none");
    setTimeout(() => {
        input.nativeElement.focus();
    }, 500);
}